// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__jNGfj","box":"LoadingSpinner_box__gpnGd","spinner":"LoadingSpinner_spinner__ScpHK"};